import "chartjs-adapter-date-fns";

import { Chart, registerables } from "chart.js";

Chart.register(...registerables);

export default {
	install: () => {
		//
	},
};
